interface TableSkeletonRowsProps {
  columnCount: number;
}

/** Placeholder rows for the first load, before there is anything to dim. */
export function TableSkeletonRows({ columnCount }: TableSkeletonRowsProps) {
  return Array.from({ length: 5 }, (_, index) => (
    <tr key={`skeleton-${index}`} className='border-t border-line'>
      {Array.from({ length: columnCount }, (__, cell) => (
        <td key={`skeleton-cell-${cell}`} className='px-3.5 py-3'>
          <span className='block h-3 w-full animate-pulse rounded-xs bg-fill' />
        </td>
      ))}
    </tr>
  ));
}
